import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 400) {
                    this.handle400(error);
                } else if (error.status === 412) {
                    this.handle412(error);
                } else {
                    this.handleGeneric(error);
                }
                return throwError(error);
            })
        );
    }

    private handle400(error: HttpErrorResponse) {
        var promise = new Promise<string>((resolver) => {
            if (error.error && error.error.errors) {
                const validationErrors = error.error.errors;
                const errorKeys = Object.getOwnPropertyNames(validationErrors);
                const errorString = errorKeys.map((errorKey) => errorKey + ': ' + validationErrors[errorKey]).join('\n ');
                resolver('Validation failed: ' + errorString);
            } else if (error.error && error.error.type === 'application/problem+json') {
                const blob = error.error as Blob;
                blob.text().then((text) => {
                    const problemDetails = JSON.parse(text);
                    const msg = problemDetails.detail || problemDetails.title || 'An error occurred';
                    resolver(msg);
                });
            } else {
                resolver(error.error && error.error.reason ? error.error.reason : '');
            }
        });

        return promise.then((msg) => {
            const snack = this.injector.get(MatSnackBar);
            const action = $localize`:@@Dismiss:Dismiss`;
            snack.open(msg, action, {
                duration: 15000,
            });
        });
    }

    private handle412(error: HttpErrorResponse) {
        const snack = this.injector.get(MatSnackBar);
        const msg = $localize`:@@NewVersionHint:A new version is available, click to refresh the page.`;
        const action = $localize`:@@Refresh:Refresh`;
        snack
            .open(msg, action, {
                duration: 150000,
            })
            .afterDismissed()
            .subscribe(() => window.location.reload());
    }

    private handleGeneric(error: HttpErrorResponse) {
        const snack = this.injector.get(MatSnackBar);
        const msg = $localize`:@@SomethingWentWrong:Something went wrong`;
        const action = $localize`:@@Dismiss:Dismiss`;
        snack.open(msg, action, {
            duration: 15000,
        });
    }
}
